import React from 'react';

import imgSpinner from 'assets/img/spinner.svg';
import styled from 'styled-components';
import IComponentProps from 'interfaces/IComponentProps';

const Spinner = styled.span`
  display:inline-block;
  width:99px;
  height:99px;
  background: url(${imgSpinner});
  background-repeat:no-repeat;
  background-position:center;
  animation: spin 1s infinite linear;
  @keyframes spin{
    0% {transform:rotate(0)};
    100% {transform:rotate(360deg)};
  }
`;

export default ({className}:IComponentProps) => <Spinner className={`spinner ${className}`}/>;